<template>
  <div class="bordered-group vs-card vs-con-block mt-5">
    <div class="vs-card-content">
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-table max-items="10" :data="transferSchedules">
            <template slot="header">
              <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0">
                <div class="vx-col w-1/3">
                  <h6>ข้อมูลตารางสรุปการโอนเงิน</h6>
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th>#</vs-th>
              <vs-th>วันที่ (ตามแผน)</vs-th>
              <vs-th>ประเภท (ตามแผน)</vs-th>
              <vs-th>จำนวนเงินที่ต้องโอน (ตามแผน)</vs-th>
              <vs-th>วันที่โอนเงิน</vs-th>
              <vs-th>ประเภท</vs-th>
              <vs-th>จำนวนเงินที่โอน</vs-th>
              <vs-th class="col-approved">สถานะประมวลผล</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                <vs-td class="text-center">{{ index + 1 }}</vs-td>
                <vs-td class="text-center">{{ row.date }}</vs-td>
                <vs-td class="text-center">{{ row.loanDetailType }}</vs-td>
                <vs-td class="text-right">{{ row.amount | numberFormat }}</vs-td>
                <vs-td class="text-center">{{ row.transferDate }}</vs-td>
                <vs-td class="text-center">{{ row.transferLoanDetailType }}</vs-td>
                <vs-td class="text-right">{{ row.transferAmount | numberFormat }}</vs-td>
                <vs-td>
                  <vs-chip :color="row.transferProcessed ? 'success' : 'warning'" v-if="row.transferId">{{ row.transferProcessed ? 'ประมวลผลแล้ว' : 'รอประมวลผล' }}</vs-chip>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapState: mapAccountingFields } = createNamespacedHelpers('Accounting');

export default {
  name: 'TransferSchedulesTab',
  computed: {
    ...mapAccountingFields(['contractDetailTransferSchedules']),
    transferSchedules() {
      if (!this.contractDetailTransferSchedules) return [];
      return this.contractDetailTransferSchedules.map((contractDetailTransferSchedule) => {
        let {
          id, date, loanDetailType, amount, transferId, transferLoanDetailType, transferDate, transferAmount, transferProcessed,
        } = contractDetailTransferSchedule;
        if (!id) {
          date = '';
          loanDetailType = '';
          amount = 0;
        }
        if (!transferId) {
          transferDate = '';
          transferLoanDetailType = '';
          transferAmount = 0;
        }
        return {
          id,
          date,
          loanDetailType,
          amount,
          transferId,
          transferLoanDetailType,
          transferDate,
          transferAmount,
          transferProcessed,
        }
      })
    },
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.col-approved {
  width: 130px;
}
</style>
